export const NEXTFLOW_CONFIG = "nextflow.config";
export const SCRIPT_PIPE_HEADER = "Pipeline Script Header";
export const SCRIPT_PIPE_FOOTER = "Pipeline Script Footer";
export const SCRIPT_MODE_HEADER = "scriptModeHeader";
export const SCRIPT_MODE_FOOTER = "scriptModeFooter";
export const SCRIPT_PIPE_CONFIG = "script_pipe_config";
export const emptyConfig = {
  filename: NEXTFLOW_CONFIG,
  text: `nextflow.enable.dsl=2
$INITIAL_RUN_TYPE="gzip"
    
//* autofill
if ($HOSTNAME == "default"){
    $DOCKER_IMAGE = "quay.io/viascientific/pipeline_base_image:1.0"
}
//* autofill`,
};
export const CANNOT_DISPLAY_FILE = "<CANNOT_DISPLAY_FILE>";
